import React from 'react'
// import OurTeam from '../components/OurTeam'
import Company from '../components/Company'
import Discuss from '../components/Discuss'
// import Companygallery from '../components/Companygallery' 
import THILife from '../components/THILife'

const CompanyPage = () => {
  return (
    <>
    <Company />
    {/* <OurTeam /> */}
    <Discuss /> 
    <THILife />
    {/* <Companygallery /> */}
    </>
  )
}

export default CompanyPage
